import { render, staticRenderFns } from "./ValidationForms.vue?vue&type=template&id=ee6481b2&"
import script from "./ValidationForms.vue?vue&type=script&lang=js&"
export * from "./ValidationForms.vue?vue&type=script&lang=js&"
import style0 from "./ValidationForms.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ValidationForms.vue"
export default component.exports